import _regeneratorRuntime from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import gameSelect from './components/gameSelect.vue';
import { getBaseGameById, gameConfigSave } from "@/api/game";
import UploadImage from "@/components/upload/image.vue";
export default {
  components: {
    gameSelect: gameSelect,
    UploadImage: UploadImage
  },
  props: [],
  data: function data() {
    return {
      formData: {
        game_id: 0,
        game_type: 1,
        categoryType: 1,
        category: [],
        tag: "",
        url: "",
        url_test: "",
        description: "",
        qq: "",
        logo: "",
        images: "",
        index_logo: "",
        game_key: "",
        game_pay_secret: "",
        game_secret: ""
      },
      rules: {
        game_type: [{
          required: true,
          message: '测试状态不能为空',
          trigger: 'change'
        }],
        category_type: [{
          required: true,
          message: '游戏类型不能为空',
          trigger: 'change'
        }],
        category: [],
        tag: [],
        url: [],
        url_test: [],
        description: [],
        qq: []
      },
      game_typeOptions: [{
        "label": "正式游戏",
        "value": 0
      }, {
        "label": "测试游戏",
        "value": 1
      }],
      categoryTypeOptions: [{
        "label": "小游戏",
        "value": 0
      }, {
        "label": "H5网友",
        "value": 1
      }, {
        "label": "手游",
        "value": 2
      }],
      categoryOptions: [{
        "label": "休闲",
        "value": "休闲"
      }, {
        "label": "网游",
        "value": "网游"
      }],
      game_id: "",
      loading: false,
      is_new: true,
      dialogVisible: true,
      gameConfig: true
    };
  },
  reload: {},
  computed: {},
  watch: {},
  created: function created() {},
  mounted: function mounted() {},
  methods: {
    newGame: function newGame() {
      this.is_new = true;
      this.game_id = "";
      this.$refs['elForm'].resetFields();
    },
    selectGame: function selectGame() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this.is_new = false;
              _this.loading = true;
              if (!_this.game_id) {
                _context.next = 7;
                break;
              }
              _context.next = 5;
              return getBaseGameById(_this.game_id);
            case 5:
              res = _context.sent;
              if (res.code == 0) {
                _this.formData = res.data;
                _this.loading = false;
              }
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    submitForm: function submitForm() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var rs;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return gameConfigSave(_this2.formData);
            case 2:
              rs = _context2.sent;
              if (rs.code == 0) {
                _this2.$message({
                  type: "success",
                  message: "保存成功!"
                });
                _this2.gameConfig = false;
                _this2.$nextTick(function () {
                  this.gameConfig = true;
                  this.game_id = rs.data.game_id;
                });
              } else {
                _this2.$message({
                  type: "info",
                  message: "保存失败"
                });
              }
              // TODO 提交表单
              // })
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    resetForm: function resetForm() {
      this.$refs['elForm'].resetFields();
    }
  }
};